// KIMU 2.0 — Cart drawer
// -----------------------------------------

(function () {
  'use strict';

  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  const body = drawer.querySelector('.drawer__body');
  const footer = drawer.querySelector('.drawer__footer');

  function format(money) {
    // Shopify carts devuelven precios en centavos. En CLP los "centavos" son 1/100 del peso
    // pero como CLP no tiene decimales, dividimos por 100 y formateamos con separadores es-CL.
    var n = Math.round((money || 0) / 100);
    try { return '$' + n.toLocaleString('es-CL'); }
    catch (e) { return '$' + n; }
  }

  function render(cart) {
    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <h3>Tu carrito está vacío.</h3>
          <p style="color:var(--color-text-muted);margin-bottom:1.5rem">Pero podemos arreglarlo.</p>
          <a href="/collections/todos-los-perfumes" class="btn btn-primary">Ver perfumes</a>
        </div>
      `;
      footer.innerHTML = '';
      return;
    }

    const threshold = parseInt(drawer.dataset.freeShipping || '0', 10);
    const remaining = Math.max(0, threshold - cart.total_price);
    const pct = threshold > 0 ? Math.min(100, (cart.total_price / threshold) * 100) : 100;

    const progress = threshold > 0 ? (
      remaining > 0
        ? `<div class="cart-progress">
            <div class="cart-progress__text">Te faltan <strong>${format(remaining)}</strong> para envío gratis.</div>
            <div class="cart-progress__bar"><div class="cart-progress__fill" style="width:${pct}%"></div></div>
          </div>`
        : `<div class="cart-progress"><div class="cart-progress__text">🎉 ¡Envío gratis desbloqueado!</div></div>`
    ) : '';

    const lines = cart.items.map((item) => `
      <div class="cart-line" data-line="${item.key}">
        <a href="${item.url}"><img class="cart-line__img" src="${item.image}" alt="${item.product_title}" loading="lazy"></a>
        <div>
          <div class="cart-line__title">${item.product_title}</div>
          <div class="cart-line__variant">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="cart-line__qty">
            <button data-qty-down aria-label="Disminuir">−</button>
            <input type="number" value="${item.quantity}" min="0" data-qty-input>
            <button data-qty-up aria-label="Aumentar">+</button>
          </div>
          <button class="cart-line__remove" data-remove>Eliminar</button>
        </div>
        <div class="cart-line__price">${format(item.final_line_price)}</div>
      </div>
    `).join('');

    body.innerHTML = `
      ${progress}
      ${lines}
      ${cart.item_count > 0 ? `
        <div class="cart-upsell">
          <div class="cart-upsell__title">Ya que estás acá...</div>
          <p style="margin:0;font-size:0.9rem">Prueba otro aroma sin comprometerte. Agrega un decant 3 ml a tu pedido.</p>
          <a href="/collections/decants-3ml" class="btn btn-light btn-sm" style="margin-top:0.75rem">Ver decants</a>
        </div>
      ` : ''}
    `;

    footer.innerHTML = `
      <div class="cart-totals">
        <span>Subtotal</span>
        <span>${format(cart.total_price)}</span>
      </div>
      <p style="font-size:0.75rem;color:var(--color-text-muted);text-align:center;margin:0.5rem 0">Tester 3 ml incluido en todos los perfumes · Envío e impuestos calculados al pagar.</p>
      <a href="/checkout" class="btn btn-primary btn-block">Finalizar compra</a>
    `;

    body.querySelectorAll('.cart-line').forEach((line) => {
      const key = line.dataset.line;
      line.querySelector('[data-qty-up]').addEventListener('click', () => updateQty(key, line, +1));
      line.querySelector('[data-qty-down]').addEventListener('click', () => updateQty(key, line, -1));
      line.querySelector('[data-remove]').addEventListener('click', () => setQty(key, 0));
      line.querySelector('[data-qty-input]').addEventListener('change', (e) => setQty(key, parseInt(e.target.value, 10) || 0));
    });
  }

  function updateQty(key, line, delta) {
    const input = line.querySelector('[data-qty-input]');
    const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
    setQty(key, next);
  }

  function setQty(key, quantity) {
    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then((r) => r.json())
      .then((cart) => {
        render(cart);
        if (window.kimuRefreshCart) window.kimuRefreshCart();
      });
  }

  function refresh() {
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((r) => r.json())
      .then(render);
  }

  document.addEventListener('cart:updated', (e) => render(e.detail));
  refresh();
})();
